import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {chatAnsweredAction} from "../../../actions/chatAction";
import {formatErrors} from "../../../constants";
import {toast} from "react-toastify";

const ChatAnswered = (props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const chatInfo = useSelector(state => state.chat.chatInfo);
  const chatID = useSelector(state => state.chat.chatID);

  const handleAnswered = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    dispatch(chatAnsweredAction(chatID)).then(() => {
      setLoading(false);
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  if (!chatInfo || !chatInfo.unanswered_message) {
    return null;
  }

  return <button type="button" className="switch__btn--action btn pointer" disabled={loading} onClick={handleAnswered}>
    Отвечено
  </button>;
};

export default ChatAnswered;
